import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function OrderFail() {
  const navigate = useNavigate();

  return (
    <div className="bg-bg-primary min-h-screen flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center mx-auto">
          <span className="text-4xl">✗</span>
        </div>
        <h1 className="text-3xl font-black text-white">Ödeme Başarısız</h1>
        <p className="text-text-muted">Ödeme işlemi tamamlanamadı. Lütfen tekrar deneyin veya farklı bir ödeme yöntemi seçin.</p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="bg-accent-red text-white font-bold px-6 py-3 rounded-xl hover:bg-red-700 transition"
          >
            Tekrar Dene
          </button>
          <Link
            to="/urunler"
            className="bg-white/10 text-white font-bold px-6 py-3 rounded-xl hover:bg-white/20 transition"
          >
            Ürünlere Dön
          </Link>
        </div>
      </div>
    </div>
  );
}
